import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import clientApiController from "services/client.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import {
  clientListErrorFromAction,
  mergeClientListPage,
  normalizeClientListResponse,
  normalizeClientSearchQuery,
} from "../../services/clientListContract";
export const usersAdapter = createEntityAdapter();

export const ClientSuggetionListApi = createAsyncThunk("header/suggetionlist", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .suggetionlist(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "suggetionlist"))
      .catch((error) => HandleError(thunkAPI, error, "suggetionlist"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isSearchBox: "",
  isSuggetionListView: [],
  isSearchList: "",
  isSearchName: "",
  isSearchObj: "",
  clientListError: null,
  suggestionRequestId: null,
  suggestionQueryKey: null,
  isBetaAdBanner:true,
  isApiStatus: {
    ClientSuggetionListApi: "",
  },
};

const invalidateSearch = (state) => {
  state.suggestionRequestId = null;
  state.suggestionQueryKey = null;
  state.isSuggetionListView = [];
  state.clientListError = null;
  state.isApiStatus.ClientSuggetionListApi = "";
};
const queryKey = action => normalizeClientSearchQuery(action.meta?.arg?.q);
const ownsSearch = (state, action) => Boolean(state.suggestionRequestId)
  && state.suggestionRequestId === action.meta?.requestId
  && state.suggestionQueryKey === queryKey(action);

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    reset: () => initialState,
    SearchBox: (state, action) => {
      if (state.isSearchBox && !action.payload) invalidateSearch(state);
      state.isSearchBox = action.payload;
    },
    OpenClientSearchList: (state) => {
      state.isSearchList = "open";
    },
    CloseClientSearchList: (state) => {
      state.isSearchList = "";
      invalidateSearch(state);
    },
    ClientSearchName: (state, action) => {
      if (normalizeClientSearchQuery(state.isSearchName) !== normalizeClientSearchQuery(action.payload)) invalidateSearch(state);
      state.isSearchName = action.payload;
    },
    ClientSearchObj: (state, action) => {
      state.isSearchObj = action.payload;
    },
    BetaAdBanner: (state, action) => {
      state.isBetaAdBanner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(ClientSuggetionListApi.pending, (state, action) => {
      if (state.suggestionQueryKey !== queryKey(action)) state.isSuggetionListView = [];
      state.suggestionRequestId = action.meta.requestId;
      state.suggestionQueryKey = queryKey(action);
      state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "loading" };
      state.clientListError = null;
    })
    .addCase(ClientSuggetionListApi.fulfilled, (state, action) => {
      if (!ownsSearch(state, action)) return;
      state.isSuggetionListView = mergeClientListPage(
        state.isSuggetionListView,
        normalizeClientListResponse(action.payload),
      );
      state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "succeeded" };
    })
    .addCase(ClientSuggetionListApi.rejected, (state, action) => {
      if (!ownsSearch(state, action)) return;
      state.clientListError = clientListErrorFromAction(action);
      state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "failed" };
    });    
  },
});
// Action creators are generated for each case reducer function
export const { reset, SearchBox, OpenClientSearchList, CloseClientSearchList, ClientSearchName, ClientSearchObj,BetaAdBanner } = headerSlice.actions;
export default headerSlice.reducer;
